import {Response} from '@angular/http';
import {JWT_RESPONSE_HEADER} from './interceptor';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';
import { throwError } from 'rxjs';

const INVALID_TOKEN:string='60040006';
export const INVALID_TOKEN_PRODUCT:string='60040005';
export class ErrorInterceptor {

    constructor() {

    }

    handleError(error: Response | any) {

        if (error.status == 0) {
            MessageStorage.add('error', 'Verifique su conexión a Internet');
            return {};
        } else
         if (error.error.errorCode == INVALID_TOKEN) {
            localStorage.removeItem(JWT_RESPONSE_HEADER);
            document.cookie = `${JWT_RESPONSE_HEADER}=; max-age=0; path=/`;
            if (window.location.hash !== '#/login') {
                window.location.href = '#/login?msg=Su sesión ha expirado. Por favor vuelva a ingresar.&msgType=info';
            }
            return error.error;
        } else
        if (error.error.errorCode == INVALID_TOKEN_PRODUCT) {
            // localStorage.removeItem(JWT_RESPONSE_HEADER);
            // window.location.href = `#/home?msg=${error.error.errorMessage}&msgType=warning`;
            window.location.href = `#/401?msg=No tiene acceso a LudyAccount`;
            return error.error;
        } else {
            return error.error;
        }
    }

    handleErrorObs (error: Response | any) {
        if (error.status == 0) {
            MessageStorage.add('error', 'Verifique su conexión a Internet');
            return throwError({});
        } else 
        if (error.error.errorCode == INVALID_TOKEN) {
            localStorage.removeItem(JWT_RESPONSE_HEADER);
            document.cookie = `${JWT_RESPONSE_HEADER}=; max-age=0; path=/`;

            if (window.location.hash !== '#/login') {
                window.location.href = '#/login?msg=Su sesión ha expirado. Por favor vuelva a ingresar.&msgType=info';
            }
            
            return throwError(error.error);
        } else 
        if (error.error.errorCode == INVALID_TOKEN_PRODUCT) {
            // localStorage.removeItem(JWT_RESPONSE_HEADER);
            // window.location.href = `#/home?msg=${error.error.errorMessage}&msgType=warning`;
            window.location.href = `#/401?msg=No tiene acceso a LudyAccount`;
            return throwError(error.error);
        }else {
            return throwError(error.error);
        }
    }
}